/**
 * session storageに状態を記録したり取り出したりするモジュール
 * */

type StorageKey = 'CURRENT_REVISION' | 'REVISION_UPDATED' | 'AUTH_ERROR_HAPPENED' | 'UNKNOWN_ERROR_HAPPENED'

/** 状態を取得する */
export const getItem = (storageKey: StorageKey): string | null => {
    return sessionStorage.getItem(storageKey)
}

/** 状態を更新する */
export const setItem = (storageKey: StorageKey, status: string): void => {
  sessionStorage.setItem(storageKey, status)
}

const removeItem = (storageKey: StorageKey): void => {
  sessionStorage.removeItem(storageKey)
}

/**
 * メッセージを取得する
 *
 * keyに対して何も設定されていない場合は空文字列を返す
 * また、取得後はkey/valueを削除する
 * */
export const getAndRemoveItem = (storageKey: StorageKey): string => {
  const val = getItem(storageKey)
  removeItem(storageKey)
  return val === null ? '' : val
}
